import React, { Component, ErrorInfo, ReactNode } from "react";
import { reportBackOfficeError } from "../../lib/posthog";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("ErrorBoundary caught an error:", error);
    reportBackOfficeError(error, {
      error_source: "root-error-boundary",
      component_stack: errorInfo.componentStack,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: "center" }}>
          <h2>Algo salió mal</h2>
          <p>Ha ocurrido un error inesperado. Intenta recargar la página.</p>
        </div>
      );
    }

    return this.props.children;
  }
}
